export const BlockReason = {
  Lost: 'Lost',
  Stolen: 'Stolen',
} as const;
export type BlockReason = (typeof BlockReason)[keyof typeof BlockReason];
